import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import Swiper from "swiper";
import { Scrollbar } from "swiper/modules";

const sliders = document.querySelectorAll(".values-slider");

sliders.forEach((slider, index) => {
  slider.classList.add(`values-slider-${index}`);
  const scrollbarEl = slider.querySelector(".swiper-scrollbar");
  if (scrollbarEl) {
    scrollbarEl.classList.add(`values-scrollbar-${index}`);
  }

  new Swiper(`.values-slider-${index}`, {
    modules: [Scrollbar],
    slidesPerView: 1,
    loop: false,
    scrollbar: {
      el: scrollbarEl ? `.values-scrollbar-${index}` : null,
      draggable: true,
    },
  });
});
